import classnames from "classnames";
import { Component } from "react";

interface ButtonListProps {
  alwaysOpen?: boolean;
  defaultOpen?: boolean;
  buttonLabels: string[];
  customClass?: string;
  disabled?: boolean;
  onSelect: (label: string) => void;
  selectedCondition: (label: string) => boolean;
  id?: string;
}

interface ButtonListState {
  disabled: boolean;
  open: boolean;
}

/**
 * This component takes the place of a dropdown list in a space with limited verticality. Initial implementation is in CountyPane.tsx.
 * @property defaultOpen Determines whether the accordion is expanded on initial render
 */
export default class ButtonList extends Component<ButtonListProps, ButtonListState> {
  constructor(props: ButtonListProps) {
    super(props);
    this.state = {
      disabled: props.disabled || false,
      open: props.defaultOpen || false,
    };
  }

  public componentDidUpdate(prevProps: ButtonListProps) {
    if (prevProps.disabled !== this.props.disabled) {
      this.setState({
        disabled: this.props.disabled,
      });
    }
  }

  public render() {
    return (
      <ul className={classnames("button-list", this.state.open ? "open" : "")} role="menu">
        {this.props.buttonLabels.map((label) => {
          const selected = this.props.selectedCondition(label);
          return (
            <li
              className={
                classnames(
                  "btn",
                  selected ?
                    "selected" :
                    "",
                  label.replace(/\s/g, "-"),
                  this.state.disabled ? "disabled" : "",
                  this.props.customClass,
                )
              }
              key={label}
              onClick={() => this.handleClick(label)}
              onKeyDown={(e) => { if (e.key === " " || e.key === "Enter") { e.preventDefault(); this.handleClick(label); } }}
              // doesn't need to/shouldn't be focusable if hidden
              tabIndex={this.state.open ? 0 : (selected ? 0 : -1)}
              // we don't have enough button colors to support this with QESButton
              role="button"
              data-testid={this.props.id ? ("button-list__" + label + "-" + this.props.id + "-button") : null}
            >
              {selected && <i className="fa fa-check pr5" />}
              <span className="status-label">{label}</span>
              {!this.state.open && <span className="caret" />}
            </li>
          );
        })}
      </ul>
    );
  }

  private handleClick = (label: string) => {
    if ((this.props.alwaysOpen || this.state.open) && !this.state.disabled) {
      this.props.onSelect(label);
      this.setState({
        open: false || this.props.alwaysOpen,
      });
    } else {
      this.setState({
        open: true,
      });
    }
  }
}
